var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "17",
      "height": "17"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "evenodd",
      "d": "M16.691 14.287a.3.3 0 0 0 .027-.134.3.3 0 0 0-.053-.126.6.6 0 0 0-.16-.147l-3.473-2.187-.032-.01a.3.3 0 0 0-.07-.029 1 1 0 0 0-.177-.023.7.7 0 0 0-.246.024.7.7 0 0 0-.215.107l-1.117.93h-.001a.77.77 0 0 1-.332.156q-.076.018-.12.025a.7.7 0 0 1-.163.01l-.098-.015-.23-.057a2.2 2.2 0 0 1-.367-.133 6 6 0 0 1-.418-.209v-.001c-.826-.454-1.776-1.25-2.606-2.126-.836-.882-1.562-1.857-1.929-2.654a4 4 0 0 1-.206-.508 3 3 0 0 1-.113-.477l-.005-.087a.8.8 0 0 1 .075-.272 1 1 0 0 1 .074-.138.7.7 0 0 1 .132-.147v-.002l.976-.8.002.002a.6.6 0 0 0 .203-.312.4.4 0 0 0 .019-.156.3.3 0 0 0-.04-.132l-.005-.012-1.76-3.636a.8.8 0 0 0-.17-.19.2.2 0 0 0-.056-.03.3.3 0 0 0-.074-.016v.003a.3.3 0 0 0-.12.013.4.4 0 0 0-.132.079L1.06 3.038l-.02.016a.7.7 0 0 0-.11.1 1.3 1.3 0 0 0-.253.483l-.011.082-.031.247-.005.037-.003.04h.001v.015H.625a4 4 0 0 0 .029.675c.238 2.337 2.16 5.485 4.715 8.001 2.286 2.25 5.06 3.975 7.558 4.12q.107.007.118.006.041.002.076 0c.085-.003.054-.003.083-.004h.035a1.5 1.5 0 0 0 .37-.09q.095-.035.175-.083a1 1 0 0 0 .122-.088l.02-.017 2.649-2.15a.4.4 0 0 0 .116-.14"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }